import { Button, Paper, Stack, Text, Title } from '@mantine/core';
import type React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import style from './popup-card.module.css';

type PopupCardProps = {
  onAddRule: () => void;
  onSnooze: () => void;
};

export const RateShopperPopupCard: React.FC<PopupCardProps> = ({ onAddRule, onSnooze }) => (
  <Paper className={style.popup} p={0} radius='md' shadow='xl' withBorder>
    <Stack className={style.header} gap='sm'>
      <Text className={style.kicker} size='sm'>
        <FormattedMessage {...messages.rateShopperPopupKicker} />
      </Text>
      <Title className={style.headline} order={2}>
        <FormattedMessage {...messages.rateShopperPopupHeadline} />
      </Title>
    </Stack>
    <div className={style.body}>
      <Text className={style['body-text']} size='md'>
        <FormattedMessage {...messages.rateShopperPopupBody} />
      </Text>
      <Button fullWidth fw={700} onClick={onAddRule} radius='sm' size='expanded'>
        <FormattedMessage {...messages.rateShopperPopupAddRuleButton} />
      </Button>
      <Button className={style['snooze-button']} fw={700} fullWidth onClick={onSnooze} size='expanded' variant='ghost'>
        <FormattedMessage {...messages.rateShopperPopupSnoozeButton} />
      </Button>
    </div>
  </Paper>
);
